import { DEFAULT_HEADER_COLOR, WHITE } from '@app/modules/core/header/constants/colors.constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any;

export const setStatusBarColor = (color: string = DEFAULT_HEADER_COLOR): void => {
  if (typeof window === 'undefined') return;
  if (window.app !== undefined && window.app.setStatusBarColor !== undefined) {
    window.app.setStatusBarColor(color, color);
  }
  if (window.appInterface !== undefined && window.appInterface.setStatusBarColor !== undefined) {
    window.appInterface.setStatusBarColor(color, color);
  }
  if (window.webkit !== undefined && window.webkit.messageHandlers  !== undefined
    && window.webkit.messageHandlers.setStatusBarColor) {
    window.webkit.messageHandlers.setStatusBarColor
      .postMessage({ color: color, line_color: color, status_color: WHITE });
  }
};
